import { FC } from 'react';
import { Box, Typography } from '@mui/material';

import styles from './QuickActions.module.scss';
import CustomButton from '../../../../../../../common/CustomButton';
import { QuickAction, quickActionsTypes } from '../../../../../../../types/aiChat.types';

interface QuickActionsProps {
  actions: QuickAction[];
  onActionClick: (action: QuickAction) => void;
  disabled?: boolean;
  tripPlannerActive?: boolean;
}

const QuickActions: FC<QuickActionsProps> = ({
  actions,
  onActionClick,
  disabled = false,
  tripPlannerActive = false,
}) => {
  return (
    <Box className={styles.quickActions}>
      {actions.map(action => (
        <CustomButton
          key={action.type}
          variant="outlined"
          onClick={() => onActionClick(action)}
          disabled={disabled}
          customClass={`${styles.actionButton} ${
            action.type === quickActionsTypes.trip_planner && tripPlannerActive ? styles.actionButtonActive : ''
          }`}
        >
          <Box className={styles.buttonContent}>
            <Typography
              variant="h10Semibold"
              className={styles.actionLabel}
            >
              {action.label}
            </Typography>
          </Box>
        </CustomButton>
      ))}
    </Box>
  );
};

export default QuickActions;
